let nodeSequence = 0;

export const createPlanningTemplateNodeId = () => {
  nodeSequence += 1;

  return `planning-template-node-${Date.now()}-${nodeSequence}`;
};

export const createEmptyPlanningTemplate = (languageId) => ({
  id: null,
  company_id: null,
  name: 'New template',
  name_translations: { [languageId]: '' },
  description_translations: {},
  active: true,
  is_system: false,
  nodes: [],
});

export const flattenPlanningTemplateNodes = (
  nodes,
  parentClientId = null,
  depth = 0,
) =>
  _.flatMap(nodes || [], (node, position) => {
    const clientId = createPlanningTemplateNodeId();
    const item = {
      ...node,
      client_id: clientId,
      parent_client_id: parentClientId,
      depth,
      position,
    };

    delete item.children;

    return [
      item,
      ...flattenPlanningTemplateNodes(node.children, clientId, depth + 1),
    ];
  });

export const normalizePlanningTemplateNodes = (nodes) => {
  const appendChildren = (parentClientId, depth) =>
    _.flatMap(
      _.sortBy(
        _.filter(nodes, { parent_client_id: parentClientId }),
        'position',
      ),
      (node, position) => [
        {
          ...node,
          depth,
          position,
        },
        ...appendChildren(node.client_id, depth + 1),
      ],
    );

  return appendChildren(null, 0);
};

export const planningTemplateNodesToPayload = (nodes) => {
  const childrenFor = (parentClientId) =>
    _.map(
      _.sortBy(
        _.filter(nodes, { parent_client_id: parentClientId }),
        'position',
      ),
      (node) => ({
        planning_library_item_id: node.planning_library_item_id,
        children: childrenFor(node.client_id),
      }),
    );

  return childrenFor(null);
};

export const planningTemplateFromResponse = (template) => ({
  ...template,
  nodes: flattenPlanningTemplateNodes(template.nodes),
});

export const planningTemplateCounts = (nodes) => ({
  stages: _.filter(nodes, { type: 'stage' }).length,
  substages: _.filter(nodes, { type: 'substage' }).length,
  groups: _.filter(nodes, { type: 'group' }).length,
});
